import I18n from 'I18n';
export const CATEGORY_KEYS = {
  PROPERTIES: 'PROPERTIES',
  EVENTS: 'EVENTS',
  ASSETS: 'ASSETS',
  INTEGRATIONS: 'INTEGRATIONS'
};
export const isCategoryKey = key => {
  return typeof key === 'string' && key in CATEGORY_KEYS;
};
export const categoryOptions = {
  [CATEGORY_KEYS.PROPERTIES]: {
    id: CATEGORY_KEYS.PROPERTIES,
    messageKey: 'customerDataFiltersUI.dataExplorer.categories.properties',
    displayOrder: 1
  },
  [CATEGORY_KEYS.EVENTS]: {
    id: CATEGORY_KEYS.EVENTS,
    messageKey: 'customerDataFiltersUI.dataExplorer.categories.events',
    displayOrder: 2
  },
  [CATEGORY_KEYS.ASSETS]: {
    id: CATEGORY_KEYS.ASSETS,
    messageKey: 'customerDataFiltersUI.dataExplorer.categories.assets',
    displayOrder: 3
  },
  [CATEGORY_KEYS.INTEGRATIONS]: {
    id: CATEGORY_KEYS.INTEGRATIONS,
    messageKey: 'customerDataFiltersUI.dataExplorer.categories.integrations',
    displayOrder: 4
  }
};
export const getCategoryOptions = () => {
  return Object.values(categoryOptions).sort((a, b) => a.displayOrder - b.displayOrder);
};
export const categoryStringCache = {};
export const getCategoryLabel = category => {
  if (!category) {
    return;
  }
  if (category in categoryStringCache) {
    return categoryStringCache[category];
  }
  if (!isCategoryKey(category)) {
    console.warn(`Invalid category: Cannot find translation ${category}`);
    return;
  }
  const messageKey = categoryOptions[category].messageKey;
  const translatedString = I18n.text(messageKey);
  categoryStringCache[category] = translatedString;
  return translatedString;
};